<template>
  <div class="page">
    <div class="pdf-box">
      <div>
        <div class="con-box">
          <MainTitle title="体能发育分析" tag="综合能力10分档分布" />
          <div class="clearfix mt30">
            <BasePanel
              v-if="mainData.title"
              :title="'综合能力'"
              title-color="#fff"
              head-bg="#FB834D"
              head-border-color="#FB834D"
              padding="20px"
              class="chart-item"
            >
              <div class="flex score">
                <div class="item">
                  <div>最高分</div>
                  <p :style="{color: '#FB834D'}">{{ mainData.others[0] }}</p>
                </div>
                <div class="item">
                  <div>中位数</div>
                  <p :style="{color: '#FB834D'}">{{ mainData.others[1] }}</p>
                </div>
                <div class="item">
                  <div>最低分</div>
                  <p :style="{color: '#FB834D'}">{{ mainData.others[2] }}</p>
                </div>
                <div class="item">
                  <div>标准差</div>
                  <p :style="{color: '#FB834D'}">{{ mainData.others[3] }}</p>
                </div>
                <div class="item">
                  <div>平均分</div>
                  <p :style="{color: '#FB834D'}">{{ mainData.others[4] }}</p>
                </div>
              </div>
              <LineArea
                :data-list="mainData.details"
                color="#FB834D"
                :area-color="[
                  'rgba(248, 122, 82, 0.72)',
                  'rgba(248, 122, 82, 0.06)'
                ]"
              />
              <div
                v-if="mainData.remark"
                class="tips"
                v-html="mainData.remark"
              />
            </BasePanel>
            <BasePanel
              v-for="(item, index) in barDataArray"
              :key="index"
              :title="item.title"
              padding="20px"
              class="chart-item"
            >
              <div class="flex score">
                <div class="item">
                  <div>最高分</div>
                  <p>{{ item.others[0] }}</p>
                </div>
                <div class="item">
                  <div>中位数</div>
                  <p>{{ item.others[1] }}</p>
                </div>
                <div class="item">
                  <div>最低分</div>
                  <p>{{ item.others[2] }}</p>
                </div>
                <div class="item">
                  <div>标准差</div>
                  <p>{{ item.others[3] }}</p>
                </div>
                <div class="item">
                  <div>平均分</div>
                  <p>{{ item.others[4] }}</p>
                </div>
              </div>
              <LineArea :data-list="item.details" />
              <div v-if="item.remark" class="tips" v-html="item.remark" />
            </BasePanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  synthEZDistributeTenGear,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from './BasePanel.vue'
import LineArea from '../../_components/charts/LineArea.vue'
import MainTitle from './MainTitle.vue'

export default {
  components: {
    BasePanel,
    LineArea,
    MainTitle
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      mainData: {
        others: [],
        details: []
      },
      barDataArray: [],
      colorList: [],
      classroomName: '',
      sexName: '',
      ageName: ''
    }
  },
  created() {
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    this.$enums.groupAnalysisAgeType.map((v) => {
      if (params.ageRangeTypes.indexOf(v.code) !== -1) {
        ageNames.push(v.description)
      }
    })
    this.ageName = ageNames.join('、')
    synthEZDistributeTenGear({ ...params, energyZoneType: this.type }).then(
      (res) => {
        this.mainData = res.data.synthEZDistributeTenGear
        this.barDataArray = res.data.barChart || []
      }
    )
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.score {
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
  .item {
    flex: 1;

    div {
      font-size: 9px;
      color: #666666;
    }

    p {
      margin-top: 5px;
      font-size: 22px;
      font-weight: bold;
      color: #ffa100;
      font-family: NumberFont;
    }
  }
}
.tips {
  line-height: 14px;
  border-radius: 6px;
  border-top: 1px dashed #666666;
  font-size: 12px;
  padding: 10px;
}
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 30px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 330px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
